import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import DomesticViolenceServicesDetails from '../../subdepartmentdetails/DomesticViolenceServices'


function DomesticViolenceServices() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Domestic Violence and Crisis Intervention Services || Family and Children Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Family Community Services"
            title="Domestic Violence Services"
            subtitledown="Department of Family & Children Services"
           />
            <DomesticViolenceServicesDetails/>
        </div>
    </>
  )
}

export default DomesticViolenceServices